<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
    <InstallPwa />
    <NotificationAllowPopup @setupNotifications="setupNotifications" />
  </div>
</template>

<script>
import InstallPwa from "@/components/InstallPwa";
import NotificationAllowPopup from "@/components/NotificationAllowPopup.vue";
import { mapState, mapActions } from 'vuex';
import { initializeApp } from 'firebase/app'
import userService from "./module_user/api/user-service";
let baseUrl = process.env.VUE_APP_API_URL;

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGESENDERID,
  appId: process.env.VUE_APP_FIREBASE_APPID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENTID
}

const isIOSWebView = () => {
  const ua = window.navigator.userAgent;
  const isIOS = /iPhone|iPad|iPod/.test(ua);
  const isWebView = (ua.includes("AppleWebKit") && !ua.includes("Safari"));
  return isIOS && isWebView;
};
let messaging, getToken, deleteToken;
if (!isIOSWebView()) {
  const app = initializeApp(firebaseConfig);

  import('firebase/messaging').then(({ getMessaging: _getMessaging, getToken: _getToken, deleteToken: _deleteToken }) => {
    getToken = _getToken;
    deleteToken = _deleteToken;
    messaging = _getMessaging(app);
  }).catch((e) => {
    console.warn('Failed to load Firebase Messaging:', e);
  });
}


export default {
  name: "App",
  components: { InstallPwa, NotificationAllowPopup },
  data() {
    return {
      checkConnectionPID: null,
      eventSource: null,
      isInIframe: false
    }
  },
  computed: {
    ...mapState(["userInfo"]),
    isMobile() {
      const isAndroid = /Android/i.test(navigator.userAgent);
      const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      return isAndroid || isiOS;
    },
  },
  watch: {
    userInfo(userDataNew, userDataOld) {

      //generate new token after logout
      if (!userDataNew) {
        this.disconnectSSE()
        if (!this.isInIframe) {
          if (getToken) {
            getToken(
                messaging, { vapidKey: process.env.VUE_APP_FIREBASE_VAPIDKEY }
            ).then((currentToken) => {
              // deleteToken(messaging, currentToken).then(() => {
              //   this.setupNotifications()
              // }).catch((err) => {
              //   console.log('Unable to delete token. ', err);
              // });
              this.setupNotifications()
            }).catch((err) => {
              console.log('Error retrieving registration token. ', err);
            });
          }
        }
      }

      //get new token after login
      else if (userDataNew?.userId && !userDataOld?.userId) {
        if (!this.isInIframe) {
          this.setupNotifications()
          this.connectToSSE()
        }
      }

      this.handleChatbotVisibility(userDataNew)
    },
    $route(to, from) {
      const pathsToCheck = ['/workout', '/end-workout/', '/v2/', '/v3/'];
      if (pathsToCheck.some(path => to.fullPath.includes(path))) {
        this.handleHideChatbot();
      }
      else {
        this.handleChatbotVisibility(this.userInfo)
      }
    },
  },
  async mounted() {
    // Check if running inside iframe
    this.isInIframe = window !== window.top && window.parent && window.parent.postMessage;

    const checkInterval = navigator.connection ? 1000 : 60 * 1000;
    this.checkConnectionPID = setInterval(this.checkConnection, checkInterval);
    const store = this.$store;
    const router = this.$router;

    // Only request permission if not in iframe
    if (!this.isInIframe) {
      this.requestPermission(messaging)
    }

    window.addEventListener("storage", (ev) => {
      //in safari storage events are triggered for same tab. https://stackoverflow.com/questions/61269238/safari-fires-storageevent-in-same-tab
      if (!document.hasFocus()) {
        if (!ev.key || ev.key == "userInfo") {
          window.location.reload(); //reload page
        }
      }
    });

    this.$store
      .dispatch("loadUserDetails", { 'ef-skip-logout': true })

      //disabled this navigation since profile screen is yet to be completed
      // .then((data) => {
      //   if (data && !data.passwordChanged) {
      //     return this.$router.push("/change-password");
      //   }
      // if (data && !data.goalType) {
      //   this.$router.push("/profile");
      // }
      //})
      .catch((err) => {
        this.$log.error(err)
      });

    // this.$store.subscribe((mutation) => {
    //   if (mutation.type == "logout") {
    //     this.$router.push('/ef/sign-in');
    //   }
    // });
  },
created() {
  // Check if running inside an iframe
  this.isInIframe = window !== window.top && window.parent && window.parent.postMessage;

  if (this.isInIframe) {
    // Send a message to the parent asking for data
    window.parent.postMessage({ type: 'REQUEST_PARENT_DATA' }, '*');

    // Listen for parent's response
    window.addEventListener('message', (event) => {
      if (event?.data?.type === 'RESPONSE_PARENT_DATA') {
        Object.entries(event.data.payload).forEach(([key, value]) => {
         localStorage.setItem(key, value);
        });
      
      }
    });
  } else {
    // Only listen for service worker messages if not in iframe
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event?.data?.data) {
        this.handleNotificationMessage(event.data.data);
      }
    });
  }
},

  destroyed() {
    // Only remove listener if not in iframe (and if it was added)
    if (!this.isInIframe) {
      navigator.serviceWorker.removeEventListener('message', (event) => {
      });
    }
  },

  methods: {
    ...mapActions(["setFCMToken", "setUnreadCount", "loadUserDetails"]),
    checkConnection() {
      if (navigator.connection) {
        const connection = navigator.connection;
        if (connection.downlink < 1.0 || connection.effectiveType.includes('2g')) {
          this.$store.commit("setSlowConnection", true);
        } else {
          this.$store.commit("setSlowConnection", false);
        }
      } else {
        const startTime = new Date().getTime();
        // 1.9 MB size
        fetch('https://s3.ap-southeast-1.amazonaws.com/www.elitefit.ai/images/network_test.jpg', { method: 'HEAD' })
          .then(() => {
            const duration = new Date().getTime() - startTime;
            if (duration > 3000) { // Threshold in milliseconds
              this.$store.commit("setSlowConnection", true);
            } else {
              this.$store.commit("setSlowConnection", false);
            }
          })
          .catch(() => {
            this.$store.commit("setSlowConnection", true);
          });
      }
    },
    handleShowChatbot() {
      var tidioChatScript = document.getElementById('tidioChatScript');
      if (!tidioChatScript) {
        var script = document.createElement('script');
        script.id = 'tidioChatScript'
        script.src = 'https://code.tidio.co/xiz0pksauqsu1ewimzluayzls3ikws7a.js'
        script.async = true;

        script.onload = () => {
          window.tidioChatApi.on = window.tidioChatApi.on || function (event, callback) {
            if (event === 'ready') {
              callback();
            }
          };

          window.tidioChatApi.on('ready', () => {
            this.handleUpdateTidioVisitorDetails()
          });
        };

        document.body.appendChild(script);
      }

    },

    handleHideChatbot() {

      var tidioChatIframe = document.getElementById('tidio-chat-iframe');
      if (tidioChatIframe) {
        tidioChatIframe.remove();
      }

      var tidioChat = document.getElementById('tidio-chat');
      if (tidioChat) {
        tidioChat.remove();
      }
      var tidioChatCode = document.getElementById('tidio-chat-code');
      if (tidioChatCode) {
        tidioChatCode.remove();
      }
      var tidioChatScript = document.getElementById('tidioChatScript');
      if (tidioChatScript) {
        tidioChatScript.remove();
      }
    },

    handleChatbotVisibility(userData) {

      const fullPath = this.$router?.history?.current?.fullPath || '';

      const pathsToCheck = ['/workout', '/end-workout/', '/v2/', '/v3/'];

      if (userData && !pathsToCheck.some(path => fullPath.includes(path))) {
        if (userData?.role === "CorporateHR" && userData?.corporate?.admin_chatbot_allowed) {
          this.handleShowChatbot();
        }
        else if (userData?.role === "Enduser" && userData?.corporate?.user_chatbot_allowed) {
          this.handleShowChatbot();
        }
        else {
          this.handleHideChatbot();
        }
      }
      else {
        this.handleHideChatbot();
      }
    },

    handleUpdateTidioVisitorDetails() {
      if (window?.tidioChatApi) {
        window.tidioChatApi.setVisitorData({
          email: this?.userInfo?.email,
          name: this?.userInfo?.name,
        });
      }
    },
    requestPermission() {
      // Don't request notification permission if in iframe
      if (this.isInIframe) {
        return;
      }

      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          console.log("permission granted")
          this.setupNotifications();
        } else {
        }
      });
    },
    setupNotifications() {
      // Don't setup notifications if in iframe
      if (this.isInIframe) {
        return;
      }

      if (getToken) {
        getToken(
            messaging, { vapidKey: process.env.VUE_APP_FIREBASE_VAPIDKEY }
        ).then(async (token) => {
          this.setFCMToken(token)

          if (this.userInfo.userId && !this.userInfo.isNotificationAllowed) {
            await userService.updateUserNotificationStatus({ isNotificationAllowed: true, fcmToken: token })
            await this.loadUserDetails({ 'ef-skip-logout': true });
          }
          await userService.subscribeToTopic(token, "general")
        }).catch(error => {
          console.log('Err:', error);
        });
      }
    },

    handleNotificationMessage(payload) {
      // Don't handle notification messages if in iframe
      if (this.isInIframe) {
        return;
      }

      this.setUnreadCount()
      if (payload?.body) {
        let messageData = JSON.parse(payload.body)
        if (typeof messageData === 'string') {
          messageData = JSON.parse(messageData);
        }
        if (!messageData.userId || messageData.userId === this?.userInfo?.userId) {
          const messageLines = messageData?.message ? messageData.message.split("\n") : [];

          const message = {
            render: (h) =>
              h("div", { class: "notificationMessage" }, [
                h("h5", messageData?.title),
                h(
                  "span",
                  messageLines.map((line, index) => [h("span", { key: index }, line), h("br")])
                ),
              ]),
          };

          const options = messageData?.options || {};

          if (messageData?.icon) {
            options.icon = <img src={messageData?.icon} />
          }

          options.onClick= () => {this.handleNotificationClick()}
          this.$toast(message, options);
        }
      }
    },
    handleNotificationClick(messageData) {
      const currentRoute = this.$route.path;
      const isNotificationComponentMounted = currentRoute.endsWith("/user/main");
      if (isNotificationComponentMounted) {
          this.showNotificationPopup();
        } else {
          this.$router.push("/user/main").then(() => {
            this.showNotificationPopup();
          });
        }
    },
    showNotificationPopup() {      
      this.$root.$emit("show-notification-popup");
    },
    connectToSSE() {
      // Don't connect to SSE if in iframe
      if (this.isInIframe) {
        return;
      }

      this.eventSource = new EventSource(baseUrl + `/notifications/${this?.userInfo?.userId}/stream`);
      this.eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);
        this.setUnreadCount(Number(data.unreadCount))
      };

      this.eventSource.onerror = () => {
        console.error('SSE connection error. Retrying...');
        this.disconnectSSE();
        setTimeout(this.connectToSSE, 5000); // Retry after 5 seconds
      };
    },

    // Disconnect SSE
    disconnectSSE() {
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }
    }
  },
  beforeDestroy() {
    if (this.checkConnectionPID) {
      clearInterval(this.checkConnectionPID);
      this.checkConnectionPID = null;
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;

  .modal-backdrop {
    background: rgba(0, 0, 0, 0.49);
  }

  .Vue-Toastification__toast--default {
    background-color: #8DC63F;
  }

  .Vue-Toastification__icon {
    width: 50px;
    border-radius: 5px;
  }

  .Vue-Toastification__close-button{
    outline: none !important;
  }

  .notificationMessage {
    display: flex;
    flex-direction: column;
  }
}

#app {
  height: 100%;
}

// #tidio-chat-iframe {
// width: 400px !important;
// }

@media only screen and (orientation: portrait) and (max-device-width: 1024px) {
  .mobile-msg {
    display: block;
  }
}
@media only screen and (orientation: landscape) and (max-device-width: 1024px) {
  .mobile-msg {
    display: none;
  }
}
</style>